import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import jsPDF from 'jspdf';
import Papa from 'papaparse';

const ExportButtons = ({ reportData, loading = false, dateRange }) => {
  const [exporting, setExporting] = useState(false);

  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const handleExportPDF = async () => {
    setExporting(true);
    try {
      const doc = new jsPDF();
      
      // Title
      doc?.setFontSize(18);
      doc?.text('Reporte Avanzado de Ingresos', 14, 20);
      
      // Date Range
      doc?.setFontSize(12);
      doc?.text(`Período: ${dateRange?.startDate} a ${dateRange?.endDate}`, 14, 30);
      
      // Summary Section
      doc?.setFontSize(14);
      doc?.text('Resumen Ejecutivo', 14, 45);
      doc?.setFontSize(10);
      doc?.text(`Ingresos Totales: ${formatCurrency(reportData?.summary?.totalRevenue || 0)}`, 14, 55);
      doc?.text(`Órdenes Completadas: ${reportData?.summary?.totalOrders || 0}`, 14, 62);
      doc?.text(`Valor Promedio: ${formatCurrency(reportData?.summary?.averageOrderValue || 0)}`, 14, 69);
      
      // Technician Breakdown
      doc?.setFontSize(14);
      doc?.text('Desempeño por Técnico', 14, 85);
      doc?.setFontSize(9);
      let yPos = 95;
      reportData?.technicianBreakdown?.forEach((tech, index) => {
        if (yPos > 270) {
          doc?.addPage();
          yPos = 20;
        }
        doc?.text(
          `${index + 1}. ${tech?.technicianName}: ${formatCurrency(tech?.totalRevenue)} (${tech?.completedOrders} órdenes)`,
          14,
          yPos
        );
        yPos += 7;
      });
      
      // Vehicle Type Breakdown
      if (yPos > 240) {
        doc?.addPage();
        yPos = 20;
      } else {
        yPos += 10;
      }
      doc?.setFontSize(14);
      doc?.text('Ingresos por Tipo de Vehículo', 14, yPos);
      yPos += 10;
      doc?.setFontSize(10);
      reportData?.vehicleTypeBreakdown?.forEach((vType) => {
        doc?.text(
          `${vType?.type}: ${formatCurrency(vType?.totalRevenue)} (${vType?.count} órdenes)`,
          14,
          yPos
        );
        yPos += 7;
      });
      
      // Save PDF
      doc?.save(`reporte_ingresos_${dateRange?.startDate}_${dateRange?.endDate}.pdf`);
    } catch (error) {
      console.error('Error exporting PDF:', error);
      alert('Error al exportar PDF');
    } finally {
      setExporting(false);
    }
  };

  const handleExportCSV = async () => {
    setExporting(true);
    try {
      // Prepare data for CSV
      const csvData = reportData?.rawData?.map(order => ({
        'Folio OT': order?.folioOt,
        'Fecha': new Date(order?.fechaIngreso)?.toLocaleDateString('es-MX'),
        'Total': order?.total,
        'Tipo Vehículo': order?.vehicle?.tipoVehiculo || 'N/A'
      }));

      // Convert to CSV
      const csv = Papa?.unparse(csvData);
      
      // Create download link
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link?.setAttribute('href', url);
      link?.setAttribute('download', `datos_ingresos_${dateRange?.startDate}_${dateRange?.endDate}.csv`);
      link.style.visibility = 'hidden';
      
      document.body?.appendChild(link);
      link?.click();
      document.body?.removeChild(link);
    } catch (error) {
      console.error('Error exporting CSV:', error);
      alert('Error al exportar CSV');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={handleExportPDF}
        disabled={loading || exporting || !reportData?.rawData?.length}
        className="flex items-center gap-2 px-4 py-2 bg-accent text-accent-foreground rounded-lg hover:bg-accent/90 disabled:opacity-50 disabled:cursor-not-allowed transition-smooth shadow-sm hover:shadow-md"
      >
        <Icon name={exporting ? 'Loader2' : 'FileText'} size={20} className={exporting ? 'animate-spin' : ''} />
        <span className="font-medium">Exportar PDF</span>
      </button>

      <button
        onClick={handleExportCSV}
        disabled={loading || exporting || !reportData?.rawData?.length}
        className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-smooth shadow-sm hover:shadow-md"
      >
        <Icon name={exporting ? 'Loader2' : 'Download'} size={20} className={exporting ? 'animate-spin' : ''} />
        <span className="font-medium">Exportar CSV</span>
      </button>
    </div>
  );
};

export default ExportButtons;